module.exports = __webpack_public_path__ + "da24861bc6e55a6548ddf12b4ce78393.svg";